import { Component, EventEmitter, inject, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';

// IMPORTANTE: Asegúrate de que venga de @angular/router
import { Router, RouterLink } from '@angular/router';

import { SessionService } from '../../../core/services/session.service';
import { LoadingService } from '../../../core/services/loading.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    RouterLink,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  // Inyecciones
  public loading = inject(LoadingService);
  public authService = inject(AuthService);

  @Output() toggleMenu = new EventEmitter<void>();
}
